import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Update,
    GetById
} from "adminApi/LaundryTaskApi/LaundryTask.js";
import { validateForm } from "utils/validation";
import { LaundryTaskRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditLaundryTaskForm from "./Componates/EditLaundryTaskForm";
import fields from "../json/LaundryTaskFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const   EditLaundryTask = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        LaundryTaskRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryTaskRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry Task Updated Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditLaundryTaskForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Laundry Task"
            />
        </>
    );

};

export default EditLaundryTask;
